import {Component, EventEmitter, HostBinding, Input, OnInit, Output} from '@angular/core';
import {EndUserCreditCard, EndUserCreditCardAcquirer} from '../../../../end-user/models/end-user.model';
import {FinancialOperationIcon} from '../../../../financial-operation/financial-operation-icon';
import {MobileViewService} from 'gelios-ng-admin-components';
import {formatCardDetails} from '../../../../utility/card-view-details';

@Component({
  selector: 'app-end-user-order-debt-cards',
  templateUrl: './end-user-order-debt-cards.component.html',
  styleUrls: ['./end-user-order-debt-cards.component.scss']
})
export class EndUserOrderDebtCardsComponent implements OnInit {
  protected readonly formatCardDetails = formatCardDetails;
  @HostBinding('class.profile-card__grid-row-container') cardContainer = true;
  @Input() cards: Array<EndUserCreditCard>;
  @Output() chosenCardIdEvent: EventEmitter<number | null> = new EventEmitter<number | null>(null);
  chosenCardId: number | null;

  constructor(
    public mobileViewService: MobileViewService
  ) {
  }

  acquirerIconClass(card: EndUserCreditCard): string {
    return card.acquirerTypeName ? FinancialOperationIcon.accountTypeIconClass(card.acquirerTypeName) : '';
  }

  cardClick(cardId: number) {
    this.chosenCardId = cardId;
    this.chosenCardIdEvent.emit(cardId);
  }

  resetToMainCard() {
    const getCardId = this.cards.find(card => card.main_card).id;
    this.chosenCardId = getCardId;
    this.chosenCardIdEvent.emit(getCardId);
  }

  ngOnInit() {
    this.resetToMainCard();
  }
}
